export const BANNERS = {
  "300x250": {
    gif: [
      "https://gw-creatives.s3.eu-west-1.amazonaws.com/banners/gif-v1/300x250.gif",
      "https://gw-creatives.s3.eu-west-1.amazonaws.com/banners/gif-v2/300x250.gif",
    ],
    html5: [
      "https://gw-creatives.s3.eu-west-1.amazonaws.com/banners/html5-v1/Scalelup_300x250.zip",
    ],
  },
  "336x280": {
    gif: [
      "https://gw-creatives.s3.eu-west-1.amazonaws.com/banners/gif-v1/336x280.gif",
      "https://gw-creatives.s3.eu-west-1.amazonaws.com/banners/gif-v2/336x280.gif",
    ],
  },
  "728x90": {
    gif: [
      "https://gw-creatives.s3.eu-west-1.amazonaws.com/banners/gif-v1/728x90.gif",
      "https://gw-creatives.s3.eu-west-1.amazonaws.com/banners/gif-v2/728x90.gif",
    ],
    html5: [
      "https://gw-creatives.s3.eu-west-1.amazonaws.com/banners/html5-v1/Scalelup_728x90.zip",
    ],
  },
  "160x600": {
    gif: [
      "https://gw-creatives.s3.eu-west-1.amazonaws.com/banners/gif-v1/160x600.gif",
      "https://gw-creatives.s3.eu-west-1.amazonaws.com/banners/gif-v2/160x600.gif",
    ],
    html5: [
      "https://gw-creatives.s3.eu-west-1.amazonaws.com/banners/html5-v1/Scalelup_160x600.zip",
    ],
  },
  "320x100": {
    gif: [
      "https://gw-creatives.s3.eu-west-1.amazonaws.com/banners/gif-v1/320x100.gif",
      "https://gw-creatives.s3.eu-west-1.amazonaws.com/banners/gif-v2/320x100.gif",
    ],
    html5: [
      "https://gw-creatives.s3.eu-west-1.amazonaws.com/banners/html5-v1/Scalelup_320x100.zip",
    ],
  },
  "320x50": {
    gif: [
      "https://gw-creatives.s3.eu-west-1.amazonaws.com/banners/gif-v1/320x50.gif",
      "https://gw-creatives.s3.eu-west-1.amazonaws.com/banners/gif-v2/320x50.gif",
    ],
  },
  "468x60": {
    gif: [
      "https://gw-creatives.s3.eu-west-1.amazonaws.com/banners/gif-v1/468x60.gif",
      "https://gw-creatives.s3.eu-west-1.amazonaws.com/banners/gif-v2/468x60.gif",
    ],
    html5: [
      "https://gw-creatives.s3.eu-west-1.amazonaws.com/banners/html5-v1/Scalelup_468x60.zip",
    ],
  },
  "120x600": {
    gif: [
      "https://gw-creatives.s3.eu-west-1.amazonaws.com/banners/gif-v2/120x600.gif",
    ],
  },
  "125x125": {
    gif: [
      "https://gw-creatives.s3.eu-west-1.amazonaws.com/banners/gif-v2/125x125.gif",
    ],
  },
  "200x200": {
    gif: [
      "https://gw-creatives.s3.eu-west-1.amazonaws.com/banners/gif-v2/200x200.gif",
    ],
  },
};
